import { TIMING } from './constants';

const dotPopAt = TIMING.globeFadeIn + TIMING.beforeDot;
const timezoneFadeStart = dotPopAt + TIMING.beforeTimezone;
const flattenStart =
  timezoneFadeStart + TIMING.timezoneFade + TIMING.beforeFlatten;

export const TIMELINE = {
  dotPopAt,
  timezoneFadeStart,
  flattenStart,
  endsAt: flattenStart + TIMING.flatten,
};
